export default __webpack_public_path__ + "static/Guardulhos-abbefe004ca6eff99995d2eb8f48c042.svg";